import { render, staticRenderFns } from "./ReportsListingSettingsHeader.vue?vue&type=template&id=842c2c64&"
import script from "./ReportsListingSettingsHeader.vue?vue&type=script&lang=js&"
export * from "./ReportsListingSettingsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports